'use client';

import { zodResolver } from '@hookform/resolvers/zod';
import { type FieldValues, type UseFormProps, type UseFormReturn, useForm } from 'react-hook-form';
import type { z } from 'zod';

type UseZodFormProps<TOut extends FieldValues> = Omit<UseFormProps<TOut>, 'resolver'> & {
  schema: z.ZodType<TOut>;
};

function useZodForm<TOut extends FieldValues>({
  schema,
  mode = 'onBlur',
  ...props
}: UseZodFormProps<TOut>): UseFormReturn<TOut> {
  return useForm<TOut>({
    // biome-ignore lint/suspicious/noExplicitAny: zodResolver requires type coercion for generic schema types
    resolver: zodResolver(schema as any),
    mode,
    ...props,
  });
}

export { useZodForm };
